import Vue from 'vue'
import VueI18n from 'vue-i18n'

/*
  i18n locale 설정
*/
var preProcess = (i18n, locale) => {
  if (i18n === undefined) {
    return false
  }

  if (locale === undefined) {
    i18n.locale = localStorage.getItem('language') || navigator.language || 'ko'
  } else {
    i18n.locale = locale
  }

  return true
}

/*
   axios 내 요청 시 lang 속성 변경
   html 내 lang 속성 변경
*/
var postProcess = (i18n, locale) => {
  var httpInstance = window.vue.getInstance('http')

  if (httpInstance !== undefined) {
    var axios = httpInstance.axios
    axios.defaults.headers.common['Accept-Language'] = locale
    document.querySelector('html').setAttribute('lang', locale)
  }

  return true
}

const setLocale = (locale) => {
  let i18n = window.vue.getI18n()

  if (!preProcess(i18n, locale)) {
    return
  }

  try {
    if (!i18n.messages[locale]) {
      let addCoreMessage = require('./bundle/message-' + i18n.locale + '.json')
      i18n.mergeLocaleMessage(locale, addCoreMessage)

      let addUserMessage = require('@/config/i18n/message-' + i18n.locale + '.json')
      i18n.mergeLocaleMessage(locale, addUserMessage)
    }
    localStorage.setItem('language', locale)
  } catch (error) {
    console.error('can not found locale ' + error)
  }

  postProcess(i18n, locale)
}

const setLocaleResource = async (locale) => {
  let i18n = window.vue.getI18n()

  if (!preProcess(i18n, locale)) {
    return
  }

  try {
    if (!i18n.messages[locale]) {
      let addSystemMessage = require(`./bundle/message-${i18n.locale}.json`)
      i18n.mergeLocaleMessage(locale, addSystemMessage)

      let addUserMessage = await window.vue.loadRes(`static/i18n/message-${i18n.locale}.json`)
      i18n.mergeLocaleMessage(locale, addUserMessage)

      let basePath = window.location.pathname.split('/')[1]

      let wepUserMessage = await window.vue.loadRes(basePath + '/i18n/template-' + i18n.locale + '.json').catch((ex) => {})
      i18n.mergeLocaleMessage(locale, wepUserMessage)
    }
    localStorage.setItem('language', locale)
  } catch (error) {
    console.error('can not found locale ' + error)
  }

  postProcess(i18n, locale)
}

const setLocaleRemote = (locale, data) => {
  // data 는 오브젝트 타입만 허용
  if ( typeof data === 'object') {
    console.log('data is Object')
  } else {
    console.error('data is not Object')
    return
  }

  let i18n = window.vue.getI18n()

  if (!preProcess(i18n, locale)) {
    return
  }

  try {
    if (!i18n.messages[locale]) {
      let addCoreMessage = require('./bundle/message-' + i18n.locale + '.json')
      i18n.mergeLocaleMessage(locale, addCoreMessage)

      let addUserMessage = require('@/config/i18n/message-' + i18n.locale + '.json')
      i18n.mergeLocaleMessage(locale, addUserMessage)

      i18n.mergeLocaleMessage(i18n.locale, data)
    }
    localStorage.setItem('language', locale)
  } catch (error) {
    console.error('can not found locale ' + error)
  }

  postProcess(i18n, locale)
}

// 인스턴스 생성
const createInstance = () => {
  let i18n = ''

  // window.vue.info('initLang()')

  // Router 전역 등록
  Vue.use(VueI18n)

  i18n = new VueI18n({
    fallbackLocale: 'ko',
    // silentTranslationWarn: true, // silentTranslationWarn, silentFallbackWarn
    messages: {}
  })

  return i18n
}

var langWrapper = {}
langWrapper.createInstance = createInstance
langWrapper.setLocale = setLocale
langWrapper.setLocaleResource = setLocaleResource
langWrapper.setLocaleRemote = setLocaleRemote

export default langWrapper



// WEBPACK FOOTER //
// ./src/_fdp/core/i18n/lang.js